import { render, staticRenderFns } from "./HeaderControls.vue?vue&type=template&id=53dd5e19&"
import script from "./HeaderControls.vue?vue&type=script&lang=js&"
export * from "./HeaderControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53dd5e19')) {
      api.createRecord('53dd5e19', component.options)
    } else {
      api.reload('53dd5e19', component.options)
    }
    module.hot.accept("./HeaderControls.vue?vue&type=template&id=53dd5e19&", function () {
      api.rerender('53dd5e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControls.vue"
export default component.exports